import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Stepper,
  Step,
  StepLabel,
  DialogContentText,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const steps = [" E-mail", "Código", "Nova Senha"];

export default function NewPassowrd() {
  const [open, setOpen] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const navigate = useNavigate();

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    if (activeStep < 3) {
      let newSkipped = skipped;
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };


  return (
    <div>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <DialogTitle>Alteração de Senha</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {activeStep === 0 && "Informe o e-mail vinculado a sua conta."}
            {activeStep === 1 &&
              "Informe o código que foi enviado para seu e-mail"}
            {activeStep === 2 && "Informe a sua nova senha"}
          </DialogContentText>
          <DialogContent>
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};

                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </DialogContent>
          {activeStep === 0 && (
            <TextField
              autoFocus
              required
              margin="dense"
              id="email"
              label="E-mail"
              type="email"
              autoComplete="email"
              fullWidth
            />
          )}
          {activeStep === 1 && (
            <TextField
              autoFocus
              required
              margin="dense"
              id="code"
              label="Código"
              type="text"
              autoComplete="off"
              fullWidth
            />
          )}
          {activeStep === 2 && (
            <TextField
              autoFocus
              required
              margin="dense"
              id="password"
              name="password"
              label="Código"
              type="password"
              autoComplete="new-password"
              fullWidth
            />
          )}
          {activeStep === 3 && (
            <Typography>Senha alterada com sucesso</Typography>
          )}
        </DialogContent>
        <DialogActions>
          {!(activeStep === 3) && (
            <Button color="inherit" onClick={handleClose} sx={{ mr: 1 }}>
              Cancelar
            </Button>
          )}
          <Button
            color="inherit"
            disabled={activeStep === 0 || activeStep === 3}
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            Voltar
          </Button>

          <Button
            variant="contained"
            onClick={activeStep === 3 ? handleClose : handleNext}
          >
            {activeStep === steps.length - 1
              ? "Alterar Senha"
              : activeStep === 3
              ? "Finalizar"
              : "Próximo"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
